module.exports = __webpack_public_path__ + "static/media/feed_the_ward_important.82885431.svg";